var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundScreener(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 165,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h43v87H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h43v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h147v66H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 284,
    height: 175,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Fund House Screener",
    transform: "translate(-1012 -768)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1024 782)",
    "data-name": "Group 1272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -14)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h244a8 8 0 0 1 8 8v143H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h244a7.5 7.5 0 0 1 7.5 7.5v142.5h-259V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h244a8 8 0 0 1 8 8v16H0V8a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .5h244a7.5 7.5 0 0 1 7.5 7.5v15.5H.5V8A7.5 7.5 0 0 1 8 .5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(-314 -985)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(324 994)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(332 994)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(340 994)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23h260v20H0z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5 23.5h259v19H.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(10 28)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(186 31)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1557",
    fill: "#fff",
    d: "M1036 825h64v107h-64z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 17",
    transform: "translate(1047 834)",
    clipPath: "url(#c)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(-313 -1302)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(313 1302)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 4",
    transform: "translate(313 1310)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 7)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 14)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 21)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(-313 -1253)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(313 1302)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 4",
    transform: "translate(313 1310)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 7)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 14)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(0 21)",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Fund House Screener",
    transform: "translate(1114 844)",
    fill: "#454545",
    fontSize: 11,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fund House Screener")), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1559",
    width: 151,
    height: 8,
    rx: 1,
    transform: "translate(1114 854)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 19",
    transform: "translate(1116 866)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1278",
    transform: "translate(-1114 -866)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 15",
    width: 70,
    height: 41,
    rx: 4,
    transform: "translate(1114 866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1277",
    transform: "translate(3)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1120 894)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1558",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(1130 895)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1140 873)",
    fill: "#c7cbd1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1279",
    transform: "translate(-1037 -866)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 15",
    width: 70,
    height: 41,
    rx: 4,
    transform: "translate(1114 866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1277",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1120 894)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1558",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(1130 895)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1140 873)",
    fill: "#c7cbd1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1278",
    transform: "translate(-1114 -820)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 15",
    width: 70,
    height: 41,
    rx: 4,
    transform: "translate(1114 866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1277",
    transform: "translate(3)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1120 894)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1558",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(1130 895)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1140 873)",
    fill: "#c7cbd1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1279",
    transform: "translate(-1037 -820)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 15",
    width: 70,
    height: 41,
    rx: 4,
    transform: "translate(1114 866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1277",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1120 894)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1558",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(1130 895)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1140 873)",
    fill: "#c7cbd1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundScreener);
export default __webpack_public_path__ + "static/media/fund-screener.102a9d8d5a5ed69c5b19ab9b9caa54ec.svg";
export { ForwardRef as ReactComponent };